import { UNKNOWN_ERROR } from '@shared/libs/errors-consts';
import { ErrorLayout } from '@shared/layouts/ErrorLayout';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRouteEvents } from '@shared/constants/router';

export const UnknownErrorPage: FC = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(getRouteEvents());
  };

  return <ErrorLayout error={UNKNOWN_ERROR} showBasicButton={true} navigateTo={handleNavigate} />;
};
